<template>
  <div class="layout">
    <Layout>
      <AdminHeader />
      <Layout>
        <Sider hide-trigger :style="{background: '#fff'}">
          <AdminLeftMenu />
          <div class="slider-sep"></div>
        </Sider>
        <Layout class="admin-right-wrap">
          <AdminContentBread />
          <!--页面内容主体开始-->
          <Content class="admin-wrap">
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="90">
                <FormItem label="结构名称" prop="assoName">
                  <Input v-model="formValidate.assoName" placeholder="请输入机构名称"></Input>
                </FormItem>
                <FormItem label="电子邮件" prop="assoEmail">
                  <Input v-model="formValidate.assoEmail" placeholder="请输入电子邮件"></Input>
                </FormItem>
                <FormItem label="联系电话" prop="assoTel">
                  <Input v-model="formValidate.assoTel" placeholder="请输入联系电话"></Input>
                </FormItem>
                <FormItem label="机构类型" prop="assoType">
                  <Select v-model="formValidate.assoType" placeholder="请选择机构类型">
                    <Option v-for="(item, idx) in GLOBAL_API.assoTypes" v-bind:key="idx" :value="parseInt(idx)">{{item}}</Option>
                  </Select>
                </FormItem>
                <FormItem label="站点URL" prop="website">
                  <Input v-model="formValidate.website" placeholder="请输入自有站点URL"></Input>
                </FormItem>
                <FormItem label="机构介绍" prop="assoDesc">
                  <ckeditor v-model="formValidate.assoDesc" :config="editorConfig"></ckeditor>
                </FormItem>
                <FormItem label="机构章程" prop="assoRegulations">
                  <ckeditor v-model="formValidate.assoRegulations" :config="editorConfig"></ckeditor>
                </FormItem>
                <FormItem label="组织机构" prop="assoOrganization">
                  <ckeditor v-model="formValidate.assoOrganization" :config="editorConfig"></ckeditor>
                </FormItem>
                <FormItem label="协会领导" prop="assoLeaders">
                  <ckeditor v-model="formValidate.assoLeaders" :config="editorConfig"></ckeditor>
                </FormItem>
                <FormItem label="理事会" prop="assoCouncil">
                  <ckeditor v-model="formValidate.assoCouncil" :config="editorConfig"></ckeditor>
                </FormItem>
                <FormItem label="联系信息" prop="contactInfo">
                  <ckeditor v-model="formValidate.contactInfo" :config="editorConfig"></ckeditor>
                </FormItem>
                <FormItem>
                  <Button type="primary" @click="handleSubmit('formValidate')">保存信息</Button>
                </FormItem>
            </Form>
          </Content>
          <!--页面内容主体结束-->
        </Layout>
      </Layout>
    </Layout>
  </div>
</template>
<script>
import axios from "axios"
import AdminLeftMenu from '@/components/AdminLeftMenu.vue'
import AdminContentBread from '@/components/AdminContentBread.vue'
import AdminHeader from '@/components/AdminHeader.vue'
export default {
  components: {
    AdminLeftMenu,
    AdminContentBread,
    AdminHeader
  },

  data () {
    return {
      // 文本编辑器配置
      editorConfig: {
        language: 'zh-cn',//中文包
        fileTools_requestHeaders: {
          "Authorization": ""
        },
        extraPlugins:['font', 'justify', 'colorbutton'],
        filebrowserImageUploadUrl: this.GLOBAL_API.apiUrl + '/uploads/picture-for-editor',
      },

      token: '',
      assoInfo: {},
      formValidate: {
        assoId: 0,
        assoName: '',
        assoEmail: '',
        assoTel: '',
        assoType: '',
        website: '',
        assoDesc: '', //介绍
        assoRegulations: '', //机构章程
        assoOrganization: '', //组织机构
        assoLeaders: '', //协会领导
        assoCouncil: '', //理事会
        contactInfo: '', //联系信息
      },
      ruleValidate: {
        assoName: [
          { required: true, message: '请输入机构名称', trigger: 'blur' }
        ],
        assoEmail: [
          { required: true, message: '请输入机构电子邮件', trigger: 'blur' },
          { type: 'email', message: '请您检查电子邮件格式', trigger: 'blur' }
        ],
        assoTel: [
          { required: true, message: '请输入机构联系电话', trigger: 'blur' }
        ],
        assoType: [
          { type: 'number', required: true, message: '请选择机构类型', trigger: 'change' }
        ],
        assoDesc: [
          { required: true, message: '请输入机构介绍', trigger: 'blur' },
          { type: 'string', min: 20, message: '机构介绍至少要20个字符', trigger: 'blur' }
        ],
        assoRegulations: [
          { required: true, message: '请输入机构章程', trigger: 'blur' }
        ], //机构章程
        assoOrganization: [
          { required: true, message: '请输入组织机构详情', trigger: 'blur' }
        ], //组织机构
        assoLeaders: [
          { required: true, message: '请输入机构领导情况', trigger: 'blur' }
        ], //协会领导
        assoCouncil: [
          { required: true, message: '请输入机构理事会', trigger: 'blur' }
        ], //理事会
        contactInfo: [
          { required: true, message: '请输入机构联系信息', trigger: 'blur' }
        ],
      }
    }
  },

  //页面加载完成后执行
  //页面加载完成
  mounted: function() {
    //初始化用户信息
    this.initAuthData()

    //获取机构信息
    this.getAssociationInfo()
  },

  //页面方法
  methods: {
    //初始化页面基础信息
    initAuthData() {
      let admin = JSON.parse(localStorage.getItem("adminInfo"));
      if(admin!=null) {
        this.token = admin.token
        this.editorConfig.fileTools_requestHeaders.Authorization = "Bearer " + admin.token
      }
    },

    //从服务端获取文字列表
    getAssociationInfo() {
      let vm = this  
      axios.post(
        vm.GLOBAL_API.apiUrl + "/manage/associations/association-get-for-show",
        {status: 1},
        {
          headers: {
            'content-type': 'application/json',
            "Authorization": "Bearer " + vm.token
          }
        }
      ).then(function(res) {
        let info = res.data
        vm.assoInfo = info.data
        vm.formValidate.assoId = vm.assoInfo.assoId
        vm.formValidate.assoName = vm.assoInfo.assoName
        vm.formValidate.assoEmail = vm.assoInfo.assoEmail
        vm.formValidate.assoTel = vm.assoInfo.assoTel
        vm.formValidate.assoType = parseInt(vm.assoInfo.assoTypeId)
        vm.formValidate.website = vm.assoInfo.website
        vm.formValidate.assoDesc = vm.assoInfo.assoDesc
        vm.formValidate.assoCouncil = vm.assoInfo.assoCouncil
        vm.formValidate.assoLeaders = vm.assoInfo.assoLeaders
        vm.formValidate.assoOrganization = vm.assoInfo.assoOrganization
        vm.formValidate.assoRegulations = vm.assoInfo.assoRegulations
        vm.formValidate.contactInfo = vm.assoInfo.contactInfo
      }).catch(function(error) {
        console.log(error)
      });
    },

    //表单数据提交
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          let vm = this  
          axios.post(
            vm.GLOBAL_API.apiUrl + "/manage/associations/association-save-for-edit-mine",
            vm.formValidate,
            {
              headers: {
                'content-type': 'application/json',
                "Authorization": "Bearer " + vm.token
              }
            }
          ).then(function(res) {
            let info = res.data
            let error = parseInt(info.code)
            if(error==0) {
              vm.$Message.success({
                  content: info.message,
                  duration: 2,
                  closable: true,
                  onClose:function() {
                    window.open(vm.$router.resolve({ path: '/manage/association/mine/show'}).href, "_self")
                  }
              });
            } else {
              vm.$Message.error(info.message);
            }
          }).catch(function(error) {
            console.log(error)
          });
        } else {
          this.$Message.error('表单验证失败');
        }
      })
    },

  }
}
</script>